import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import { IRouterParamsWithObjectId } from "types/routerTypes";

import { useLocationArray } from "utils/hooks/useLocationArray";

interface IObjectIdContext {
  objectIdExternal: string;
}

export const ObjectIdContext = React.createContext<IObjectIdContext>({
  objectIdExternal: "",
});

export const ObjectIdProvider: React.FC<{ objectIdExternal: string; children: React.ReactNode }> = ({
  objectIdExternal,
  children,
}) => {
  return <ObjectIdContext.Provider value={{ objectIdExternal }}>{children}</ObjectIdContext.Provider>;
};
/**
 * Хук возвращает заданный ID объекта или ID объекта из URL-параметра или ID объекта из locationArray.
 * Для установки кастомного ID объекта использовать `<ObjectIdProvider objectIdExternal={customObjectId}>{children}</ObjectIdProvider>`
 * @param indexInLocationArray - индекс элемента в locationArray
 * @returns {string} objectIdExternal || objectId || objectIdFallback
 */
export const useObjectId = (indexInLocationArray: number = 1): string => {
  const { objectId: objectIdParams } = useParams<IRouterParamsWithObjectId>();
  const { objectIdExternal } = useContext(ObjectIdContext);

  const locationArr = useLocationArray();

  const objectIdFallback: string = React.useMemo(() => {
    const candidate = locationArr[indexInLocationArray];
    if (isNaN(+candidate)) {
      return "";
    } else {
      return candidate;
    }
  }, [locationArr]);

  return objectIdExternal || objectIdParams || objectIdFallback;
};
